import { app } from "./app"
import { chat } from "./chat"
import { help } from "./help"
import { meetings } from "./meetings"
import { preview } from "./preview"
import { sidebar } from "./sidebar"
import { common } from "./common"

const namespaces = [common, app, chat, meetings, sidebar, preview, help]

export const en = Object.assign({}, ...namespaces.map((n) => n.en)) as typeof common.en &
  typeof app.en &
  typeof chat.en &
  typeof meetings.en &
  typeof sidebar.en &
  typeof preview.en &
  typeof help.en

export const de: Record<keyof typeof en, string> = Object.assign({}, ...namespaces.map((n) => n.de))

export type MessageKey = keyof typeof en
